import apiClient from '@u/apiClient'

export default {
  //region fetch
  async fetchNewPayment({ commit }, payload) {
    commit('auth/setErrors', {}, { root: true })
    await apiClient
      .get(`api/model/new?model=payment&invoice_id=${payload.invoice_id}`)
      .then(async (response) => {
        await commit('setPayment', response.data.payment)
        await commit('setPaymentMetadata', response.data.metadata)
      })
      .catch((reason) => {
        console.error('fetchNewPayment reason', reason)
      })
  },
  //endregion

  //region store
  storeNewPayment({ commit }, payload) {
    return apiClient
      .post(
        `api/invoicing/add-payment/${payload.invoice_id}`,
        payload.data_request
      )
      .then((response) => {
        commit('setInvoice', response.data.invoice)
        return response.data
      })
  },
  //endregion

  //region delete
  deletePayment({ commit }, payload) {
    return apiClient
      .delete(`api/invoicing/delete/payment/` + payload.payment_id)
      .then((response) => {
        commit('setInvoice', response.data.invoice)
        return response.data
      })
  }
  //endregion
}
